/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Menudishcount2Inputs */

const en_menudishcount2 = /** @type {(inputs: Menudishcount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dishes`)
};

const de_menudishcount2 = /** @type {(inputs: Menudishcount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Gerichte`)
};

/**
* | output |
* | --- |
* | "{count} dishes" |
*
* @param {Menudishcount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menudishcount2 = /** @type {((inputs: Menudishcount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menudishcount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menudishcount2(inputs)
	return de_menudishcount2(inputs)
});
export { menudishcount2 as "menuDishCount" }